import graphqlClient from '../../api/axios_interceptor';
import { FormDataRestClient } from '../../api/rest_interceptor';
import { GRAPHQL_API } from '../../api/graphql/endpoint';
import { getFormData } from './functions';

import {
    FETCH_EXPENSES,
    ADD_EXPENSE,
    UPDATE_EXPENSE,
    DELETE_EXPENSE
} from '../actions/actionTypes';
import { updateActionErrors } from './updateErrors';

import {
    getExpensesQuery,
    addExpenseMutation,
    updateExpenseMutation,
    deleteExpenseMutation
} from "../../api/graphql/queries/expenses";
import {convertDateToUserLocalDate} from "../../utils/general"

export const parseExpense = (expense) => {
    return{
    expenseId: expense.id,
    propertyId: expense.property? expense.property.id : "",
    unitId: expense.unit? expense.unit.id : "",
    amount: expense.amount,
    paymentMethod: expense.paymentMethod? (expense.paymentMethod.toLowerCase().replace("_", " ")): "",
    teamMemberId: expense.author ? expense.author.id : "",
    expenseDate: convertDateToUserLocalDate(expense.expenseDate),
    lastUpdated: expense.lastUpdated,
    category: expense.category? (expense.category.toLowerCase().replace("_", " ")): "",
    notes: expense.notes,
    creditNote: expense.creditNote,
    status: expense.status? (expense.status.toLowerCase().replace("_", " ")): "",
    fileName: expense.upload? expense.upload.file : "",
    fileId: expense.upload? expense.upload.id : "",
    maintenanceId: expense.maintenanceId,
}};

export const fetchExpensesMiddleware = async (action) => {
    try {
        let expenses = {};
        await graphqlClient({
            data: {
                query: getExpensesQuery(action.payload)
            },
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);

            } else {
                expenses = queryResult.data.data.expenses.expenses.map(parseExpense);
                action = ({
                    ...action,
                    payload: {
                        ...action.payload,
                        expenses
                    },
                    offset: queryResult.data.data.expenses.next,
                    summary: queryResult.data.data.expenses.summary
                });
            }
        });

    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}



const addExpenseMiddleware = async (action) => {
    try {
        const payload = action.payload;
        let query = addExpenseMutation(
            payload.propertyId, payload.unitId, payload.amount, 
            payload.paymentMethod, payload.category, payload.notes, 
            payload.creditNote, payload.status, payload.expenseDate,
            payload.maintenanceId
        );
        const formData = getFormData(query, action.payload.fileUpload);
        
        await FormDataRestClient.post(
            GRAPHQL_API, 
            formData
        ).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);

            } else if (queryResult.data.data.addExpense.error) {
                action = updateActionErrors(action, queryResult.data.data.addExpense.error.message);
            }
            else {
                action = ({
                    ...action,
                    payload: {
                        ...payload,
                        expense: parseExpense(queryResult.data.data.addExpense.expense)
                    }
                });
            }
        })
    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}

const updateExpenseMiddleware = async (action) => {
    try {
        const payload = action.payload;
        let query = updateExpenseMutation(payload.expenseId, {
            amount: payload.amount,
            propertyId: payload.propertyId, 
            unitId: payload.unitId,
            paymentMethod: payload.paymentMethod, 
            category: payload.category, 
            notes: payload.notes, 
            creditNote: payload.creditNote, 
            status: payload.status, 
            expenseDate: payload.expenseDate,
            updateFile: payload.updateFile
        });
        const formData = getFormData(query, action.payload.fileUpload);
        await FormDataRestClient.post(
            GRAPHQL_API, formData
        ).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);

            } else if (queryResult.data.data.updateExpense.error) {
                action = updateActionErrors(action, queryResult.data.data.updateExpense.error.message);
            }
            else {
                action = ({
                    ...action,
                    payload: {
                        ...payload,
                        expense: parseExpense(queryResult.data.data.updateExpense.expense)
                    }
                });
            }
        })
    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}


const deleteExpenseMiddleware = async action => {
    try {
        let payload = action.payload;
        await graphqlClient({
            data: {
                query: deleteExpenseMutation(payload.expenseId)
            }
        }).then((queryResult) => {
            if (queryResult.data.errors) {
                action = updateActionErrors(action, queryResult.data.errors);
            } else if (queryResult.data.data.deleteExpense.error) {
                action = updateActionErrors(action, queryResult.data.data.deleteExpense.error.message);
            }
            else {
                action = ({
                    ...action,
                    payload: {
                        ...payload,
                        success: queryResult.data.data.deleteExpense.success
                    }
                });
            }
        })
    } catch (error) {
        console.log(error);
        action = updateActionErrors(action, error);
    }
    return action;
}



export const expensesMiddleware = storeAPI => next => async action => {
    switch (action.type) {
        case FETCH_EXPENSES:
            action = await fetchExpensesMiddleware(action);
            break;
        case ADD_EXPENSE:
            action = await addExpenseMiddleware(action);
            break;
        case UPDATE_EXPENSE:
            action = await updateExpenseMiddleware(action);
            break;
        case DELETE_EXPENSE:
            action = await deleteExpenseMiddleware(action);
            break;
    }
    return next(action);
}
